import variables from '../../../utils/variables';
import React from 'react';
import * as PropTypes from 'prop-types';
import logo1 from '../../../assets/validatorsOn/Cheqd.png';
import logo2 from '../../../assets/validatorsOn/Akash.png';
import logo3 from '../../../assets/validatorsOn/COMDEX.png';
import logo4 from '../../../assets/validatorsOn/juno.LOGO.png';
import logo5 from '../../../assets/validatorsOn/xki.svg';
import logo10 from '../../../assets/validatorsOn/ki_foundation_logo.png';
import logo7 from '../../../assets/validatorsOn/like_coin.svg';
import logo8 from '../../../assets/validatorsOn/Osmosis.png';
import logo9 from '../../../assets/validatorsOn/SENTINEL.png';
import logo6 from '../../../assets/validatorsOn/stargaze new logo.png';
import './index.css';

const ValidatorOn = (props) => {
    return (
        <section className="validator_on">
            <div className="heading">
                <h2>{variables[props.lang]['validator_on']}</h2>
                <span/>
            </div>
            <div className="row">
                <div className="row_slide">
                    <img alt="logo1" src={logo1}/>
                    <img alt="logo2" src={logo2}/>
                    <img alt="logo3" src={logo3}/>
                    <img alt="logo4" src={logo4}/>
                    <img alt="logo5" src={logo5}/>
                    <img alt="logo6" src={logo6}/>
                    <img alt="logo7" src={logo7}/>
                    <img alt="logo8" src={logo8}/>
                    <img alt="logo9" src={logo9}/>
                    <img alt="logo10" src={logo10}/>
                </div>
                <div className="row_slide">
                    <img alt="logo1" src={logo1}/>
                    <img alt="logo2" src={logo2}/>
                    <img alt="logo3" src={logo3}/>
                    <img alt="logo4" src={logo4}/>
                    <img alt="logo5" src={logo5}/>
                    <img alt="logo6" src={logo6}/>
                    <img alt="logo7" src={logo7}/>
                    <img alt="logo8" src={logo8}/>
                    <img alt="logo9" src={logo9}/>
                    <img alt="logo10" src={logo10}/>
                </div>
            </div>
        </section>
    );
};

ValidatorOn.propTypes = {
    lang: PropTypes.string.isRequired,
};

export default ValidatorOn;
